import React from "react"
import { func, string } from "prop-types";
import styled from "styled-components"

import { ReactComponent as MetamaskSVG } from "../assets/images/metamask.svg";

export const MetamaskStyledSVG = styled(MetamaskSVG)`
	width: 1em;
	height: 1em;
 	align-self: center;
 	vertical-align: center;
`
